
import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
@Component({})
export default class OficinaTuristica extends Vue {
  private win = window;
  private base = window.location;
  private left = false;
  private listAtractivos: Array<any> = [];
  private nombreWeb: any = "";

  private mounted() {
    this.atractivos();
  }

  private atractivos() {
    axios
      .get("atractivos/list")
      .then((res: any) => {
        this.listAtractivos = res.data;
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  private routerGo(name: string) {
    if (name && name != "") {
      if (this.$router.currentRoute.name == name) {
        this.$router.go(0);
      } else {
        this.$router.push({ name: name }).catch(err => {
          console.log(err);
        });
      }
    }
  }

  private atractivoGo(nombreWeb: any) {
    if (
      this.$router.currentRoute.name == "DetalleAtractivo" &&
      this.$router.currentRoute.params.nombre == nombreWeb
    ) {
      this.$router.go(0);
    } else {
      this.$router
        .push({
          name: "DetalleAtractivo",
          params: { nombre: nombreWeb }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
}
